"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePersonalSuccess = exports.UpdatePasswordSuccess = exports.UpdateEmailSuccess = exports.SendConfirmEmailSuccess = exports.ConfirmEmailSucccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpdateEmailSuccess = function UpdateEmailSuccess() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('settings.emailUpdated.description'),
    type: "success",
    title: t('settings.emailUpdated.title')
  });
};
exports.UpdateEmailSuccess = UpdateEmailSuccess;
var ConfirmEmailSucccess = function ConfirmEmailSucccess() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('settings.emailConfirmed.description'),
    type: "success",
    title: t('settings.emailConfirmed.title')
  });
};
exports.ConfirmEmailSucccess = ConfirmEmailSucccess;
var SendConfirmEmailSuccess = function SendConfirmEmailSuccess() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('settings.sendConfirmEmail.description'),
    type: "success",
    title: t('settings.sendConfirmEmail.title')
  });
};
exports.SendConfirmEmailSuccess = SendConfirmEmailSuccess;
var UpdatePasswordSuccess = function UpdatePasswordSuccess() {
  var _useTranslation4 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('settings.passwordUpdated.description'),
    type: "success",
    title: t('settings.passwordUpdated.title')
  });
};
exports.UpdatePasswordSuccess = UpdatePasswordSuccess;
var UpdatePersonalSuccess = function UpdatePersonalSuccess() {
  var _useTranslation5 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation5.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('settings.personalUpdated.description'),
    type: "success",
    title: t('settings.personalUpdated.title')
  });
};
exports.UpdatePersonalSuccess = UpdatePersonalSuccess;